<template>
<div class="comments_body">
  <van-tabs v-model="active">
    <van-tab title="评论">
      <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
      <div class="neirong" v-for="item in 6">
        <div class="touxiang"><img src="/6.jpeg"></div>
        <div class="xinxi">
          <div class="name">罗超</div>
          <div class="miaoshu">可以约你出来看电影吗</div>
        </div>
        <div class="shijian">昨天23：58</div>
        <div class="biaoqian">2</div>
        <div style="clear: both"></div>
        <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
      </div>
    </van-tab>
    <van-tab  disabled></van-tab>
    <van-tab  disabled></van-tab>
    <van-tab  disabled></van-tab>
  </van-tabs>
</div>
</template>

<script>
    export default {
        name: "comments",
        data(){
            return{
                active:0,
            }
        }
    }
</script>

<style scoped lang="stylus">
.comments_body{
  width 100%;
  /*>>>.van-tabs__line{
    background-color transparent
  }*/
  .neirong{
    width 95%;
    margin 10px auto;
    position relative;
    .touxiang{
      float left;
      img{
        width 60px;
        height 60px;
        border-radius 30px;
      }
    }
    .xinxi{
      float left;
      margin-left 10px;
      margin-top 5px;
      .name{
        font-size 16px;
        color #333333;
        font-weight 500
      }
      .miaoshu{
        color #c0c0c0
      }
    }
    .shijian{
      position absolute;
      right 10px;
    }
    .biaoqian{
      background-color red;
      width 20px;
      height 20px;
      border-radius 10px;
      position absolute;
      right 10px;
      color #fff;
      text-align center;
      line-height 20px;
      top 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wode/comments.vue